module.exports = __webpack_public_path__ + "static/media/explore-bg.e92fb710.png";